import styled from "styled-components";
import { components, MenuProps } from "react-select";
import css from "@styled-system/css";
import { XcoreTheme } from "design-system/xcore/theme";
import { BoxProps, Box, useTheme } from "@xcorejs/ui";
import { OptionType } from ".";

export type MenuSelectProps = BoxProps & {
  _inner?: BoxProps;
};

const MenuStyle = styled(Box)<MenuSelectProps>`
  * {
    position: relative;
    z-index: 10000;
  }

  ${({ _inner }) =>
    css({
      "& > div": _inner,
    })}
`;

export const Menu = <T extends OptionType, M extends boolean>({ children, ...props }: MenuProps<T, M>) => {
  const theme = useTheme() as XcoreTheme;
  const menuProps = theme.select.menu;

  return (
    <MenuStyle {...menuProps}>
      <components.Menu {...props}>{children}</components.Menu>
    </MenuStyle>
  );
};
